interface SailthruConfig {
  customerId: string;
  hostWebsiteType: "spa" | undefined;
  overlayKeyValue?: Record<string, string>;
}

export interface SailthruOptions {
  email: string;
  lists: { [key: string]: number };
  vars?: { [key: string]: string | boolean | number };
  onSuccess?: () => void;
  onError?: ({ error }: { error: Error }) => void;
}

export function getCurrentDate(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

declare global {
  interface Window {
    Sailthru?: {
      init(config: SailthruConfig): void;
      integration(action: "userSignUp", options: SailthruOptions): void;
    };
  }
}

interface SignupOptions extends Omit<SailthruOptions, "lists"> {
  lists?: SailthruOptions["lists"];
}

const useSailthru = () => {
  function signUp(options: SignupOptions) {
    if (!window.Sailthru) {
      console.error("Error: Sailthru is not initialized");
      throw new Error("unable to process sign up.");
    }

    window.Sailthru?.integration("userSignUp", {
      ...options,
      lists: {
        "Master List": 1,
        ...options.lists,
      },
    });
  }

  return {
    signUp,
  };
};

export default useSailthru;
